import styled from 'styled-components';

const BlogStyle = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;

    padding-bottom: 100px;
	overflow: hidden;
    
    .section {
        width: 100%;
        padding: 0 32px;
    }
    
    .blog {
        &-link {
            width: 100%;
            max-width: 326px;
            cursor: pointer;
        }
        
        &-header {
            display: flex;
            align-items: center;
            flex-direction: column;
        }
        
        &-hello {
            background: white;
            border-radius: 33px;
            width: 100%;
            padding: 21px 33px;
            display: flex;
            justify-content: center;
            min-height: 242px;
            position: relative;

            &-content {
                justify-content: space-between;
                align-items: center;
                display: flex;
                width: 100%;
                max-width: 1026px;
            }
            
            &-image {
                padding: 0;
                position: absolute;
                right: 33px;
                top: 21px;
                width: 634px;
                height: 200px;
            }
        }
        &-previews {
            display: flex;
            flex-wrap: wrap;
            gap: 24px;
            justify-content: center;
            margin: 40px auto 0;
            align-items: self-start;
        }
        &-block {
            max-width: 743px;
            margin-top: 39px;
            &-text {
                margin-top: 25px;
            }
            &-list {
                margin-top: 20px;
                margin-left: 16px;
                li {
                    margin-top: 22px;
                }
            }
            &-image {
                margin-top: 40px;
            }
            &-title {
                margin-top: 40px;
            }
        }
        &-image {
            margin-top: 29px;
        }
    }
    

    .blog-title {
        margin-top: 24px;
    }
    
    .sub-title {
        margin-top: 15px;
    }
    
    .main-gray {
        color: #838383;
    }
    
    .text-gray {
        color: #515151;
    }
    
    .divider {
        width: 100%;
        height: 8px;
        background: #3A3A3A;
        margin: 66px 0 40px;
    }
    
    .response {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 60px;
    }
    .related {
        display: flex;
        gap: 26px;
        margin-top: 29px;
        flex-wrap: wrap;
    }

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
        
    }

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
        .blog-previews {
            justify-content: space-around;
        }
        .blog-hello-content {
            flex-direction: column;
        }
        .blog-hello-image {
            display: none;
        }
        
        .blog-hello {
            flex-direction: column;
            align-items: center;
            min-height: auto;
        }
    }

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
        padding-bottom: 90px;

        .blog-hello-image {
            display: none;
        }
        .blog-hello {
            flex-direction: column;
            align-items: center;
            min-height: auto;
        }

        .blog-previews {
            justify-content: space-around;
        }
        .blog-hello-content {
            flex-direction: column;
        }

        .blog-title {
            margin-top: 14px;
        }

        .sub-title {
            margin-top: 5px;
        }
        
        .blog-image {
            margin-top: 19px;
        }

        .blog-block {
            margin-top: 29px;
        }

        .blog-block-image {
            margin-top: 30px;
        }
        
        .divider {
            margin: 56px 0 30px;
        }
        
        .response {
            margin-bottom: 50px;
        }
        
        .blog-block-title {
            margin-top: 30px;
        }
        
        .blog-block-text {
            margin-top: 15px;
        }
        
        .blog-block-list li {
            margin-top: 12px;
        }

        .blog-block {
            width: 100%;
            padding: 0 32px;
        }
        
        .related {
            flex-direction: column;
            margin-top: 19px;
            gap: 16px;
        }
    }
`;

export default BlogStyle;
